<script lang="ts">
    import AutoCarousel from "./AutoCarousel.svelte";
    import {platform} from "../store/store";
    import {fetchProductImages, getSiteUrl} from "../utils/fetchProductImages";

    export let id: string;
    export let productHover: boolean;
    export let maxWidth: number;
    export let productURL: string;
    export let style: string;
    export let imageURL: string;

    let images = [];

    $: if ($platform === "Shopify") {
        fetchProductImages({
            siteURL: getSiteUrl(),
            productURL: productURL
        }).then(productImages => images = productImages).catch(e => {
            console.error(e);
        });
    }

</script>

<AutoCarousel style={style} id={id} maxWidth={maxWidth} images={images} imageURL={imageURL}
              productHover={productHover}/>
